/*
=========================================================
* Material Kit 2 React - v2.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import { Link } from "react-router-dom";
import { styled } from "@mui/material/styles";
import ReactPlayer from "react-player";
import MKTypography from "components/MKTypography";
import bgBlue from "../../../assets/images/bg-blue.svg";

const HeadingText = styled("div")({
  color: "#0A0A0A",
  backgroundColor: "transparent",
  padding: 1,
  textTransform: "uppercase",
  opacity: "0.8",
  fontWeight: "400",
  fontFamily: "inherit",
  fontSize: "30px",
});
const CourseCard = styled("div")({
  backgroundColor: "#f6e18f",
  paddingTop: 38,
  textAlign: "center",
  justifyContent: "center",
  border: "1px solid rgba(10, 10, 10, 0.1)",
  boxShadow: "0px 2px 4px -2px rgba(10, 10, 10, 0.2)",
  width: "100%",
  minHeight: "180px",
});
const Course = styled("div")({
  // border: "2px solid #fcc907",
  padding: "2px",
  boxShadow: "0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24)",
});
const CourseType = styled("div")({
  color: "white",
  opacity: 0.8,
  textTransform: "uppercase",
  fontWeight: 500,
});
const CourseDuration = styled("div")({
  color: "white",
  opacity: 0.8,
  fontWeight: 500,
});
function Information() {
  return (
    <Container sx={{ mt: 0, mb: 3 }}>
      <MKTypography variant="h2" py={3}>
        <HeadingText className="heading-bg" sx={{ fontWeight: "bold" }}>
          Programmes Offered
        </HeadingText>
      </MKTypography>
      <Grid container spacing={3} alignItems="center" mt={1} className="parent-c">
        <Grid item xs={12} lg={6} sx={{ mx: "auto" }}>
          <img src={bgBlue} alt="" className="bg-blue" />
          <Grid container item xs={12} spacing={3} alignItems="center" className="courseBg">
            <Grid item xs={12} lg={4} sx={{ mx: "auto" }}>
              <Link className="course-links" to="/academics/courses/ba-llb">
                <Course>
                  <CourseCard className="courses-card">
                    <h3>B.A LL.B</h3>
                    <CourseType>
                      <h6>Honours</h6>
                    </CourseType>
                    <CourseDuration>5 Year Course</CourseDuration>
                  </CourseCard>
                </Course>
              </Link>
            </Grid>
            <Grid item xs={12} lg={4} sx={{ mx: "auto" }}>
              <Link className="course-links" to="/academics/courses/ba-llb">
                <Course>
                  <CourseCard className="courses-card">
                    <h3>B.B.A LL.B</h3>
                    <CourseType>
                      <h6>Honours</h6>
                    </CourseType>
                    <CourseDuration>5 Year Course</CourseDuration>
                  </CourseCard>
                </Course>
              </Link>
            </Grid>
            <Grid item xs={12} lg={4} sx={{ mx: "auto" }}>
              <Link className="course-links" to="/academics/courses/ba-llb">
                <Course>
                  <CourseCard className="courses-card">
                    <h3>B.Com LL.B</h3>
                    <CourseType>
                      <h6>Honours</h6>
                    </CourseType>
                    <CourseDuration>5 Year Course</CourseDuration>
                  </CourseCard>
                </Course>
              </Link>
            </Grid>
            <Grid item xs={12} lg={4} sx={{ mx: "auto" }}>
              <Link className="course-links" to="/academics/courses/unitary-llb">
                <Course>
                  <CourseCard className="courses-card">
                    <h3>UNITARY LL.B</h3>
                    <CourseType>{/* <h4>Honours</h4> */}</CourseType>
                    <CourseDuration>3 Year Course</CourseDuration>
                  </CourseCard>
                </Course>
              </Link>
            </Grid>
            <Grid item xs={12} lg={4} sx={{ mx: "auto" }}>
              <Link className="course-links" to="/academics/courses/llm">
                <Course>
                  <CourseCard className="courses-card">
                    <h3>LL.M</h3>
                    <CourseType>
                      <h6>(Criminal Law)</h6>
                    </CourseType>
                    <CourseDuration>2 Year Course</CourseDuration>
                  </CourseCard>
                </Course>
              </Link>
            </Grid>
            <Grid item xs={12} lg={4} sx={{ mx: "auto" }}>
              <Link className="course-links" to="/academics/courses/llm">
                <Course>
                  <CourseCard className="courses-card">
                    <h3>LL.M</h3>
                    <CourseType>
                      <h6>(Commercial Law)</h6>
                    </CourseType>
                    <CourseDuration>2 Year Course</CourseDuration>
                  </CourseCard>
                </Course>
              </Link>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} lg={6} sx={{ mx: "auto" }} className="courseimgBg">
          <ReactPlayer
            controls
            loop
            playing
            url="https://snlc-files.s3.ap-south-1.amazonaws.com/videos/snlc_video.mp4"
            // light="https://d1l8ubyc91nwpi.cloudfront.net/static/media/snlc-bg-2.e1f1f05e.webp"
            className="snlc_player"
            width="100%"
          />
        </Grid>
      </Grid>
    </Container>
  );
}

export default Information;
